import React from 'react';

import { MCButton, PopoverMenu, SelectField } from './basic';
import { events, lang, remCss, useScreenDetail } from '../helpers';

const LangSelect = ({ isPopover, ...props }) => {
  const screen = useScreenDetail();
  if (isPopover || screen.isSmallScreen)
    return (
      <PopoverMenu
        style={{ cursor: 'pointer' }}
        placement={'bottom-end'}
        arrowOffset={-90}
        menu={(close) => (
          <ul
            className={'mc-select-field-items'}
            style={{
              backgroundColor: 'white',
              padding: remCss(5)
            }}
          >
            {lang.allowedLanguages.map((l) => (
              <MCButton
                small
                key={l.value}
                onClick={() => {
                  close();
                  events.emit('initLang', l.value);
                }}
                tertiary={l.value !== lang.language}
                primary={l.value === lang.language}
              >
                {lang.t(l.label)}
              </MCButton>
            ))}
          </ul>
        )}
      >
        {() => (
          <MCButton
            radius
            tiny
            outline
            style={{ padding: remCss(5), paddingTop: remCss(7) }}
            label={lang.language.toUpperCase()}
          />
        )}
      </PopoverMenu>
    );
  return (
    <SelectField
      width={remCss(150)}
      options={lang.allowedLanguages}
      isClearable={false}
      value={lang.language}
      onChange={(n, v) => events.emit('initLang', v)}
      name={'lang'}
      {...props}
    />
  );
};


LangSelect.displayName = 'LangSelect';

export default LangSelect;
